export default __webpack_public_path__ + "static/media/icon-linkedin.32e20978.svg";